import { useState, useEffect } from 'react';
import api from '../api';

const ROW_H = 34;
const HEAD1_H = 30;
const HEAD2_H = 26;
const LABEL_W = 200;
const COL_W = 62;
const TOTAL_W = 80;

const fmtN  = v => v == null ? '—' : Number(v).toLocaleString('ru-RU');
const fmtP  = v => v == null ? '—' : Number(v).toFixed(1) + '%';
const fmtR  = v => v == null ? '—' : Number(v).toLocaleString('ru-RU') + ' ₽';
const toISO = d => d.toISOString().split('T')[0];

function getWeeks(start, days) {
  const result = [];
  const end = new Date(start);
  end.setDate(end.getDate() + Number(days) - 1);
  let cur = new Date(start);
  let w = 1;
  while (cur <= end) {
    const from = new Date(cur);
    const to = new Date(cur); to.setDate(to.getDate() + 6);
    if (to > end) to.setTime(end.getTime());
    const ds = [];
    let d = new Date(from);
    while (d <= to) { ds.push(toISO(d)); d.setDate(d.getDate()+1); }
    result.push({ label:`W${w}`, from:toISO(from), to:toISO(to), days:ds });
    cur.setDate(cur.getDate()+7); w++;
  }
  return result;
}

function sumW(days, map, fn) {
  let t = null;
  for (const d of days) { const v = fn(map[d]||{}); if (v!=null) t=(t||0)+Number(v); }
  return t;
}
function avgW(days, map, fn) {
  let t=0, c=0;
  for (const d of days) { const v = fn(map[d]||{}); if (v!=null){t+=Number(v);c++;} }
  return c>0 ? Math.round(t/c*10)/10 : null;
}

// ─── МЕТРИКИ блока 1 (факт всего) ───────────────────────────────────────────
const FACT_METRICS = [
  { key:'imp',   label:'Показы',              group:'ПОКАЗЫ',     fmt:fmtN, fn:d=>d.impressions||null,  sum:true },
  { key:'tr',    label:'Переходы',            group:'ПОКАЗЫ',     fmt:fmtN, fn:d=>d.openCount||null,    sum:true },
  { key:'ctr',   label:'CTR %',               group:'ПОКАЗЫ',     fmt:fmtP, fn:d=>d.ctr||null,          sum:false },
  { key:'cart',  label:'Корзины',             group:'КОРЗИНЫ',    fmt:fmtN, fn:d=>d.cartCount||null,    sum:true },
  { key:'ctr2',  label:'Конв. переход→корзина', group:'КОРЗИНЫ',  fmt:fmtP, fn:d=>d.convTrCart!=null?d.convTrCart:(d.openCount?Math.round(d.cartCount/d.openCount*100*10)/10:null), sum:false },
  { key:'ord',   label:'Заказы',              group:'ЗАКАЗЫ',     fmt:fmtN, fn:d=>d.ordersQty||null,    sum:true },
  { key:'ctr3',  label:'Конв. корзина→заказ', group:'ЗАКАЗЫ',     fmt:fmtP, fn:d=>d.convCartOrd!=null?d.convCartOrd:(d.cartCount?Math.round(d.ordersQty/d.cartCount*100*10)/10:null), sum:false },

  { key:'ordS',  label:'Сумма заказов',       group:'СУММЫ',      fmt:fmtR, fn:d=>d.ordersSum||null,    sum:true },

  { key:'spd',   label:'Затраты рекламы',     group:'РЕКЛАМА',    fmt:fmtR, fn:d=>d.spendAll||null,     sum:true },
];

// ─── МЕТРИКИ блока 2 (реклама отдельно) ─────────────────────────────────────
const ADV_METRICS = [
  { key:'advImp', label:'Показы рекламы',      group:'ПОКАЗЫ РК',   fmt:fmtN, fn:d=>d.viewsAll||null,       sum:true },
  { key:'advCl',  label:'Клики',               group:'ПОКАЗЫ РК',   fmt:fmtN, fn:d=>d.clicksAll||null,      sum:true },
  { key:'advCtr', label:'CTR рекламы %',       group:'ПОКАЗЫ РК',   fmt:fmtP, fn:d=>(d.viewsAll&&d.clicksAll)?Math.round(d.clicksAll/d.viewsAll*100*10)/10:null, sum:false },
  { key:'advCart',label:'Корзины рекламы',     group:'КОРЗИНЫ РК',  fmt:fmtN, fn:d=>d.advAtbs||null,        sum:true },
  { key:'advOrd', label:'Заказы рекламы',      group:'ЗАКАЗЫ РК',   fmt:fmtN, fn:d=>d.advOrdersQty||null,   sum:true },
  { key:'advSpd', label:'Затраты рекламы',     group:'БЮДЖЕТ',      fmt:fmtR, fn:d=>d.spendAll||null,       sum:true },
];

// ─── Горизонтальная таблица ──────────────────────────────────────────────────
function HTable({ weeks, dayMap, metrics, today, profitRK, profitNoRK, buyoutAvg, price, drr, buyoutHistory=[], weekSnapshots=[] }) {
  // Получаем исторический % выкупа для недели
  const getBuyout = (week) => {
    const hist = buyoutHistory.find(h => h.weekFrom <= week.from && h.weekTo >= week.to);
    return hist ? hist.buyoutPct : buyoutAvg;
  };
  const getSnap = (week) => {
    return weekSnapshots.find(s => s.weekFrom === week.from) || null;
  };
  const allCols = [];
  for (const w of weeks) {
    for (const d of w.days) allCols.push({ type:'day', date:d, week:w });
    allCols.push({ type:'total', week:w });
  }

  const totalW = LABEL_W + allCols.reduce((a,c)=>a+(c.type==='total'?TOTAL_W:COL_W),0);

  return (
    <div style={{ overflowX:'auto' }}>
      <div style={{ minWidth:totalW }}>

        {/* Шапка 1 — недели */}
        <div style={{ display:'flex', position:'sticky', top:0, zIndex:4, background:'#0a0f1a' }}>
          <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:HEAD1_H, position:'sticky', left:0, zIndex:5, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', borderBottom:'1px solid rgba(255,255,255,0.08)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, fontWeight:600, color:'rgba(200,215,235,0.5)' }}>Показатель</div>
          {weeks.map(w => {
            const wW = w.days.length*COL_W + TOTAL_W;
            const isCur = w.from<=today && w.to>=today;
            const isPast = w.to<today;
            return <div key={w.label} style={{ width:wW, minWidth:wW, flexShrink:0, height:HEAD1_H, display:'flex', alignItems:'center', gap:12, paddingLeft:8, background:isCur?'rgba(99,102,241,0.12)':isPast?'rgba(255,255,255,0.03)':'rgba(255,255,255,0.01)', borderRight:'1px solid rgba(255,255,255,0.08)', borderBottom:'1px solid rgba(255,255,255,0.08)', boxSizing:'border-box' }}>
              <span style={{ fontSize:11, fontWeight:700, color:isCur?'#a5b4fc':'rgba(200,215,235,0.7)', whiteSpace:'nowrap' }}>{w.from.slice(5)} — {w.to.slice(5)}</span>
              {(isPast||isCur) && buyoutAvg!=null && <span style={{ fontSize:10, color:'rgba(200,215,235,0.4)', whiteSpace:'nowrap' }}>Выкуп: {getBuyout(w)}%</span>}
              {(isPast||isCur) && (getSnap(w)?.profitRK ?? profitRK)!=null && <span style={{ fontSize:10, color:'rgba(200,215,235,0.4)', whiteSpace:'nowrap' }}>Прибыль с РК: {fmtR(getSnap(w)?.profitRK ?? profitRK)}</span>}
            </div>;
          })}
        </div>

        {/* Шапка 2 — даты */}
        <div style={{ display:'flex', position:'sticky', top:HEAD1_H, zIndex:4, background:'#0a0f1a' }}>
          <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:HEAD2_H, position:'sticky', left:0, zIndex:5, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', borderBottom:'1px solid rgba(255,255,255,0.1)' }}/>
          {allCols.map((col,ci) => {
            const isT = col.type==='total';
            const isToday = !isT && col.date===today;
            const isFut = !isT && col.date>today;
            const isCur = col.week.from<=today && col.week.to>=today;
            return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:HEAD2_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.18)':isToday?'rgba(251,191,36,0.12)':isFut?'rgba(255,255,255,0.01)':isCur?'rgba(99,102,241,0.06)':'transparent', borderRight:isT?'2px solid rgba(255,255,255,0.15)':'1px solid rgba(255,255,255,0.04)', borderBottom:'1px solid rgba(255,255,255,0.1)', fontSize:10, fontWeight:isToday||isT?700:400, color:isT?'#a5b4fc':isToday?'#fbbf24':isFut?'rgba(200,215,235,0.25)':'rgba(200,215,235,0.5)', boxSizing:'border-box' }}>
              {isT ? 'Итого' : col.date.slice(5)}
            </div>;
          })}
        </div>

        {/* Строки */}
        {metrics.map((m, mi) => {
          const isNewGroup = mi===0 || metrics[mi-1].group!==m.group;
          return (
            <div key={m.key}>
              {isNewGroup && (
                <div style={{ display:'flex', height:20 }}>
                  <div style={{ width:LABEL_W, minWidth:LABEL_W, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12 }}>
                    <span style={{ fontSize:9, fontWeight:700, color:'rgba(200,215,235,0.3)', textTransform:'uppercase', letterSpacing:'0.8px' }}>{m.group}</span>
                  </div>
                  {allCols.map((_,ci)=><div key={ci} style={{ width:_.type==='total'?TOTAL_W:COL_W, minWidth:_.type==='total'?TOTAL_W:COL_W, flexShrink:0, background:'rgba(255,255,255,0.01)' }}/>)}
                </div>
              )}
              <div style={{ display:'flex', height:ROW_H, borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, color:'rgba(200,215,235,0.8)' }}>{m.label}</div>
                {allCols.map((col,ci) => {
                  const isT = col.type==='total';
                  const isToday = !isT && col.date===today;
                  const isFut = !isT && col.date>today;
                  const isCur = col.week.from<=today && col.week.to>=today;
                  let val = null;
                  if (isT) {
                    val = m.sum ? sumW(col.week.days, dayMap, m.fn) : avgW(col.week.days, dayMap, m.fn);
                  } else if (!isFut) {
                    val = m.fn(dayMap[col.date]||{});
                  }
                  const empty = val==null;
                  return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.1)':isToday?'rgba(251,191,36,0.06)':isCur?'rgba(99,102,241,0.04)':'transparent', borderRight:isT?'2px solid rgba(255,255,255,0.1)':'1px solid rgba(255,255,255,0.03)', fontSize:10, color:empty?'rgba(200,215,235,0.18)':isT?'#a5b4fc':isToday?'#fbbf24':'rgba(200,215,235,0.85)', fontWeight:isT||isToday?600:400, boxSizing:'border-box' }}>
                    {empty ? '—' : m.fmt(val)}
                  </div>;
                })}
              </div>
            </div>
          );
        })}

        {/* Строки окупаемости по дням */}
        {profitRK != null && buyoutAvg != null && (
          <div style={{ display:'flex', height:ROW_H, borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, color:'rgba(200,215,235,0.8)' }}>Прибыль за день (оценка)</div>
            {allCols.map((col,ci) => {
              const isT = col.type==='total';
              const isFut = !isT && col.date>today;
              if (isFut) return <div key={ci} style={{ width:COL_W, minWidth:COL_W, flexShrink:0, borderRight:'1px solid rgba(255,255,255,0.03)' }}/>;
              const d = isT ? null : (dayMap[col.date]||{});
              const orders = isT ? sumW(col.week.days, dayMap, x=>x.ordersQty||null) : (d?.ordersQty||null);
              const weekBuyout = getBuyout(col.week);
              const buyoutsFrac = orders!=null ? orders * (weekBuyout/100) : null;
              const profit = buyoutsFrac!=null && profitNoRK!=null ? Math.round(buyoutsFrac * profitNoRK) : null;
              const isCur = col.week.from<=today && col.week.to>=today;
              return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.1)':isCur?'rgba(99,102,241,0.04)':'transparent', borderRight:isT?'2px solid rgba(255,255,255,0.1)':'1px solid rgba(255,255,255,0.03)', fontSize:10, color:profit==null?'rgba(200,215,235,0.18)':profit>=0?'#10b981':'#ef4444', fontWeight:isT?600:400 }}>
                {profit==null?'—':fmtR(profit)}
              </div>;
            })}
          </div>
        )}
        {/* Строка окупаемости рекламы — только если есть profitRK */}
        {profitRK != null && (
          <div style={{ display:'flex', height:ROW_H+4, borderBottom:'1px solid rgba(255,255,255,0.08)', borderTop:'1px solid rgba(255,255,255,0.08)' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H+4, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, fontWeight:700, color:'rgba(200,215,235,0.9)' }}>Реклама окупилась</div>
            {allCols.map((col,ci) => {
              const isT = col.type==='total';
              const isFut = !isT && col.date>today;
              const spend = sumW(col.week.days, dayMap, d=>d.spendAll!=null?d.spendAll:null);
              const advOrd = sumW(col.week.days, dayMap, d=>d.advOrdersQty!=null?Number(d.advOrdersQty):null);
              // По дням — показываем +/− разницу
              if (col.type==='day') {
                const isFut = col.date > today;
                if (isFut) return <div key={ci} style={{ width:COL_W, minWidth:COL_W, flexShrink:0, borderRight:'1px solid rgba(255,255,255,0.03)' }}/>;
                const dd = dayMap[col.date]||{};
                const ord = dd.ordersQty||null;
                const spd = dd.spendAll||null;
                const bf = ord!=null ? ord*(getBuyout(col.week)/100) : null;
                const pv = bf!=null && profitNoRK!=null ? Math.round(bf*profitNoRK) : null;
                const res = pv!=null && spd!=null ? pv - Math.round(spd) : null;
                const isCurD = col.week.from<=today && col.week.to>=today;
                return <div key={ci} style={{ width:COL_W, minWidth:COL_W, flexShrink:0, height:ROW_H+4, display:'flex', alignItems:'center', justifyContent:'center', background:isCurD?'rgba(99,102,241,0.04)':'transparent', borderRight:'1px solid rgba(255,255,255,0.03)', fontSize:10, color:res==null?'rgba(200,215,235,0.18)':res>=0?'#10b981':'#ef4444' }}>
                  {res==null?'—':(res>=0?'+':'')+fmtR(res)}
                </div>;
              }
              // По итогу недели — накопленная сумма за прошедшие дни (каждый день обновляется)
              const passedDays = col.week.days.filter(d => d <= today);
              const weekSpendPassed = sumW(passedDays, dayMap, d=>d.spendAll!=null?d.spendAll:null);
              if (passedDays.length===0 || weekSpendPassed==null) return <div key={ci} style={{ width:TOTAL_W, minWidth:TOTAL_W, flexShrink:0, height:ROW_H+4, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(99,102,241,0.1)', borderRight:'2px solid rgba(255,255,255,0.1)', fontSize:12, color:'rgba(200,215,235,0.3)' }}>—</div>;
              const weekOrders = sumW(passedDays, dayMap, x=>x.ordersQty||null);
              const weekBf = weekOrders!=null ? weekOrders*(getBuyout(col.week)/100) : null;
              const weekPv = weekBf!=null && profitNoRK!=null ? Math.round(weekBf*profitNoRK) : null;
              const result = weekPv!=null && weekSpendPassed!=null ? weekPv - Math.round(weekSpendPassed) : null;
              const ok = result!=null && result >= 0;
              return <div key={ci} style={{ width:TOTAL_W, minWidth:TOTAL_W, flexShrink:0, height:ROW_H+4, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', background:ok?'rgba(16,185,129,0.12)':'rgba(239,68,68,0.1)', borderRight:'2px solid rgba(255,255,255,0.1)', gap:2 }}>
                <span style={{ fontSize:14 }}>{ok?'✓':'✗'}</span>
                <span style={{ fontSize:9, color:ok?'#10b981':'#ef4444' }}>{result!=null?(ok?'+':'')+fmtR(result):'—'}</span>
              </div>;
            })}
          </div>
        )}

        {/* ДРР % — между Реклама окупилась и Бюджетная окупаемость */}
        {buyoutAvg != null && (
          <div style={{ display:'flex', height:ROW_H, borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, color:'rgba(200,215,235,0.8)' }}>ДРР %</div>
            {allCols.map((col,ci) => {
              const isT = col.type==='total';
              const isFut = !isT && col.date>today;
              if (isFut) return <div key={ci} style={{ width:COL_W, minWidth:COL_W, flexShrink:0, borderRight:'1px solid rgba(255,255,255,0.03)' }}/>;
              const days = isT ? col.week.days.filter(d=>d<=today) : [col.date];
              const spend = isT ? sumW(days, dayMap, d=>d.spendAll||null) : (dayMap[col.date]?.spendAll||null);
              const ordSum = isT ? sumW(days, dayMap, d=>d.ordersSum||null) : (dayMap[col.date]?.ordersSum||null);
              const weekBuyoutDrr = getBuyout(col.week);
              const drr = (spend!=null && ordSum!=null && ordSum>0 && weekBuyoutDrr>0)
                ? Math.round(spend / (ordSum * weekBuyoutDrr/100) * 100 * 10) / 10
                : null;
              const isCur = col.week.from<=today && col.week.to>=today;
              return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.1)':isCur?'rgba(99,102,241,0.04)':'transparent', borderRight:isT?'2px solid rgba(255,255,255,0.1)':'1px solid rgba(255,255,255,0.03)', fontSize:10, color:drr==null?'rgba(200,215,235,0.18)':drr<=5?'#10b981':drr<=15?'#f59e0b':'#ef4444', fontWeight:isT?600:400 }}>
                {drr==null?'—':drr+'%'}
              </div>;
            })}
          </div>
        )}

        {/* Бюджетная окупаемость — только для завершённых недель */}
        {profitRK != null && buyoutAvg != null && price != null && drr != null && (
          <div style={{ display:'flex', height:ROW_H+4, borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H+4, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, fontWeight:700, color:'#f59e0b' }}>Бюджетная окупаемость</div>
            {allCols.map((col,ci) => {
              const isT = col.type==='total';
              if (!isT) return <div key={ci} style={{ width:COL_W, minWidth:COL_W, flexShrink:0, borderRight:'1px solid rgba(255,255,255,0.03)' }}/>;
              const weekDone = col.week.to < today;
              if (!weekDone) return <div key={ci} style={{ width:TOTAL_W, minWidth:TOTAL_W, flexShrink:0, height:ROW_H+4, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(99,102,241,0.1)', borderRight:'2px solid rgba(255,255,255,0.1)', fontSize:12, color:'rgba(200,215,235,0.3)' }}>—</div>;
              const weekOrders = sumW(col.week.days, dayMap, x=>x.ordersQty||null);
              const weekSpend  = sumW(col.week.days, dayMap, x=>x.spendAll!=null?x.spendAll:null);
              const limitPerOrder = price*(buyoutAvg/100)*(drr/100);
              const partA = weekOrders!=null ? Math.round(weekOrders*(buyoutAvg/100)*profitRK) : null;
              const partB = (weekSpend!=null&&weekOrders!=null) ? weekSpend - weekOrders*limitPerOrder : null;
              const result = (partA!=null&&partB!=null) ? Math.round(partA - partB) : null;
              const ok = result!=null && result >= 0;
              return <div key={ci} style={{ width:TOTAL_W, minWidth:TOTAL_W, flexShrink:0, height:ROW_H+4, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', background:ok?'rgba(16,185,129,0.12)':'rgba(239,68,68,0.1)', borderRight:'2px solid rgba(255,255,255,0.1)', gap:2 }}>
                <span style={{ fontSize:14 }}>{ok?'✓':'✗'}</span>
                <span style={{ fontSize:9, color:ok?'#10b981':'#ef4444' }}>{result!=null?(ok?'+':'')+fmtR(result):'—'}</span>
              </div>;
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Блок 3: корректировка ───────────────────────────────────────────────────
function ForecastEdit({ conv, weeks, today, profitRK, profitNoRK }) {
  const futureWeeks = weeks.filter(w=>w.to>=today);
  const [p, setP] = useState({
    transitions: Math.round(conv?.avgTransitions||0),
    convTrCart:  Math.round((conv?.convTrCart||0)*10)/10,
    convCartOrd: Math.round((conv?.convCartOrd||0)*10)/10,
    buyoutPct:   30,
    drr:         5,
  });
  const set = k => v => setP(prev=>({...prev,[k]:Number(v)}));

  const daysLeft = futureWeeks.reduce((a,w)=>a+w.days.filter(d=>d>=today).length,0);
  const trPerDay = p.transitions;
  const cartPerDay = Math.round(trPerDay * p.convTrCart/100);
  const ordPerDay = Math.round(cartPerDay * p.convCartOrd/100);
  const buyPerDay = Math.round(ordPerDay * p.buyoutPct/100);
  const profitDay = buyPerDay * (profitNoRK||0);
  const spendDay = ordPerDay * (trPerDay>0 ? trPerDay*(p.drr/100) : 0);

  const Field = ({label, k, suffix}) => (
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
      <span style={{ fontSize:10, color:'rgba(200,215,235,0.45)', textTransform:'uppercase' }}>{label}</span>
      <div style={{ display:'flex', alignItems:'center', gap:4 }}>
        <input type="number" value={p[k]} onChange={e=>set(k)(e.target.value)} style={{ width:80, background:'#0f111a', border:'1px solid rgba(255,255,255,0.12)', borderRadius:6, color:'#fff', fontSize:13, fontWeight:600, padding:'6px 8px', outline:'none', textAlign:'right' }}/>
        {suffix && <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)' }}>{suffix}</span>}
      </div>
    </div>
  );

  const M = ({label, value, accent}) => (
    <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
      <span style={{ fontSize:10, color:'rgba(200,215,235,0.4)', textTransform:'uppercase' }}>{label}</span>
      <span style={{ fontSize:16, fontWeight:700, color:accent||'rgba(200,215,235,0.9)' }}>{value}</span>
    </div>
  );

  return (
    <div style={{ padding:16 }}>
      <div style={{ display:'flex', gap:20, flexWrap:'wrap', marginBottom:16 }}>
        <Field label="Переходы/день" k="transitions" suffix="шт"/>
        <Field label="Конв. переход→корзина" k="convTrCart" suffix="%"/>
        <Field label="Конв. корзина→заказ" k="convCartOrd" suffix="%"/>
        <Field label="% выкупа" k="buyoutPct" suffix="%"/>
        <Field label="ДРР %" k="drr" suffix="%"/>
      </div>
      <div style={{ display:'flex', gap:20, flexWrap:'wrap', padding:'14px 16px', background:'rgba(255,255,255,0.03)', borderRadius:10, border:'1px solid rgba(255,255,255,0.08)' }}>
        <M label="Дней осталось" value={daysLeft}/>
        <div style={{ width:1, height:36, background:'rgba(255,255,255,0.1)' }}/>
        <M label="Корзин/день" value={cartPerDay}/>
        <M label="Заказов/день" value={ordPerDay}/>
        <M label="Выкупов/день" value={buyPerDay}/>
        <div style={{ width:1, height:36, background:'rgba(255,255,255,0.1)' }}/>
        <M label={`Заказов за ${daysLeft} дн`} value={fmtN(ordPerDay*daysLeft)}/>
        <M label={`Выкупов за ${daysLeft} дн`} value={fmtN(buyPerDay*daysLeft)}/>
        <M label="Прибыль (без РК)" value={fmtR(profitDay*daysLeft)} accent="#10b981"/>
      </div>
    </div>
  );
}

// ─── Блок 4: авто-прогноз ────────────────────────────────────────────────────
function AutoForecast({ weeks, dayMap, today, profitRK, profitNoRK, conv, buyoutAvg }) {
  // Прошедшие недели сезона
  const pastWeeks = weeks.filter(w => w.to < today);

  // Среднее в день из прошедших недель (или из conv если нет данных сезона)
  const allPastDays = pastWeeks.flatMap(w => w.days).filter(d => dayMap[d]);
  const avg = fn => {
    let t=0, c=0;
    for (const d of allPastDays) { const v=fn(dayMap[d]||{}); if(v!=null){t+=Number(v);c++;} }
    return c>0 ? t/c : null;
  };

  const hasSeasonData = allPastDays.length > 0;
  const avgTr    = hasSeasonData ? avg(d=>d.openCount||null)    : (conv?.avgTransitions||null);
  const avgCart  = hasSeasonData ? avg(d=>d.cartCount||null)    : (avgTr&&conv?.convTrCart ? avgTr*conv.convTrCart : null);
  const avgOrd   = hasSeasonData ? avg(d=>d.ordersQty||null)    : (avgCart&&conv?.convCartOrd ? avgCart*conv.convCartOrd : null);
  const avgSpend = hasSeasonData ? avg(d=>d.spendAll||null)     : (conv?.avgSpend||null);
  const avgAdvOrd= hasSeasonData ? avg(d=>d.advOrdersQty||null) : (conv?.avgAdClicks&&conv?.convClickCartAd&&conv?.convCartOrdAd ? conv.avgAdClicks*conv.convClickCartAd*conv.convCartOrdAd : null);
  const avgImp   = hasSeasonData ? avg(d=>d.impressions||null)  : (conv?.avgImpressions||null);
  const convTC   = avgTr&&avgCart ? avgCart/avgTr*100 : null;
  const convCO   = avgCart&&avgOrd ? avgOrd/avgCart*100 : null;
  const buyout   = buyoutAvg || 30;

  const dataSource = hasSeasonData
    ? `${pastWeeks.length} завершённых нед сезона`
    : 'последних 7 дней до сезона';

  // Прогноз на день
  const getForecast = (date) => {
    if (dayMap[date]) return { ...dayMap[date], isFact:true }; // факт
    return {
      impressions:   avgImp   != null ? Math.round(avgImp)   : null,
      openCount:     avgTr    != null ? Math.round(avgTr)     : null,
      cartCount:     avgCart  != null ? Math.round(avgCart)   : null,
      ordersQty:     avgOrd   != null ? Math.round(avgOrd)    : null,
      buyoutQty:     avgOrd   != null ? Math.round(avgOrd * buyout/100) : null,
      spendAll:      avgSpend != null ? Math.round(avgSpend*100)/100 : null,
      advOrdersQty:  avgAdvOrd!= null ? Math.round(avgAdvOrd) : null,
      convTrCart:    convTC   != null ? Math.round(convTC*10)/10 : null,
      convCartOrd:   convCO   != null ? Math.round(convCO*10)/10 : null,
      buyoutPct:     buyout,
      isForecast:    true,
    };
  };

  // Строим виртуальный dayMap — только прогноз, никакого факта
  const forecastMap = {};
  const forecastDay = {
    impressions:   avgImp   != null ? Math.round(avgImp)   : null,
    openCount:     avgTr    != null ? Math.round(avgTr)     : null,
    cartCount:     avgCart  != null ? Math.round(avgCart)   : null,
    ordersQty:     avgOrd   != null ? Math.round(avgOrd)    : null,
    buyoutQty:     avgOrd   != null ? Math.round(avgOrd * buyout/100) : null,
    spendAll:      avgSpend != null ? Math.round(avgSpend*100)/100 : null,
    advOrdersQty:  avgAdvOrd!= null ? Math.round(avgAdvOrd) : null,
    convTrCart:    convTC   != null ? Math.round(convTC*10)/10 : null,
    convCartOrd:   convCO   != null ? Math.round(convCO*10)/10 : null,
    buyoutPct:     buyout,
  };
  for (const w of weeks) {
    for (const d of w.days) {
      forecastMap[d] = forecastDay;
    }
  }

  const allCols = [];
  for (const w of weeks) {
    for (const d of w.days) allCols.push({ type:'day', date:d, week:w });
    allCols.push({ type:'total', week:w });
  }

  const totalW = LABEL_W + allCols.reduce((a,c)=>a+(c.type==='total'?TOTAL_W:COL_W),0);

  return (
    <div>
      <div style={{ fontSize:11, color:'rgba(200,215,235,0.45)', padding:'10px 16px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
        Прогноз на основе {dataSource} · % выкупа из финотчёта: {buyout}% · факт = реальные данные, прогноз = серым
      </div>
      <div style={{ overflowX:'auto' }}>
        <div style={{ minWidth:totalW }}>
          {/* Шапка 1 — недели */}
          <div style={{ display:'flex', position:'sticky', top:0, zIndex:4, background:'#0a0f1a' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:HEAD1_H, position:'sticky', left:0, zIndex:5, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', borderBottom:'1px solid rgba(255,255,255,0.08)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, fontWeight:600, color:'rgba(200,215,235,0.5)' }}>Показатель</div>
            {weeks.map(w => {
              const wW = w.days.length*COL_W + TOTAL_W;
              const isPast = w.to < today;
              const isCur = w.from<=today && w.to>=today;
              return <div key={w.label} style={{ width:wW, minWidth:wW, flexShrink:0, height:HEAD1_H, display:'flex', alignItems:'center', gap:10, paddingLeft:8, background:isCur?'rgba(99,102,241,0.12)':isPast?'rgba(255,255,255,0.03)':'rgba(255,255,255,0.01)', borderRight:'1px solid rgba(255,255,255,0.08)', borderBottom:'1px solid rgba(255,255,255,0.08)', boxSizing:'border-box' }}>
                <span style={{ fontSize:11, fontWeight:700, color:isPast?'rgba(200,215,235,0.7)':isCur?'#a5b4fc':'rgba(200,215,235,0.4)', whiteSpace:'nowrap' }}>{w.from.slice(5)} — {w.to.slice(5)}</span>
                {isPast && <span style={{ fontSize:9, color:'#10b981', background:'rgba(16,185,129,0.15)', padding:'2px 6px', borderRadius:4 }}>факт</span>}
                {!isPast && !isCur && <span style={{ fontSize:9, color:'rgba(200,215,235,0.35)', background:'rgba(255,255,255,0.05)', padding:'2px 6px', borderRadius:4 }}>прогноз</span>}
              </div>;
            })}
          </div>
          {/* Шапка 2 — даты */}
          <div style={{ display:'flex', position:'sticky', top:HEAD1_H, zIndex:4, background:'#0a0f1a' }}>
            <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:HEAD2_H, position:'sticky', left:0, zIndex:5, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', borderBottom:'1px solid rgba(255,255,255,0.1)' }}/>
            {allCols.map((col,ci) => {
              const isT = col.type==='total';
              const isToday = !isT && col.date===today;
              const isFact = !isT && !!dayMap[col.date];
              const isCur = col.week.from<=today && col.week.to>=today;
              return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:HEAD2_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.18)':isToday?'rgba(251,191,36,0.12)':isFact?'rgba(255,255,255,0.02)':'rgba(255,255,255,0.005)', borderRight:isT?'2px solid rgba(255,255,255,0.15)':'1px solid rgba(255,255,255,0.04)', borderBottom:'1px solid rgba(255,255,255,0.1)', fontSize:10, fontWeight:isToday||isT?700:400, color:isT?'#a5b4fc':isToday?'#fbbf24':isFact?'rgba(200,215,235,0.5)':'rgba(200,215,235,0.2)', boxSizing:'border-box' }}>
                {isT ? 'Итого' : col.date.slice(5)}
              </div>;
            })}
          </div>
          {/* Строки метрик */}
          {FACT_METRICS.map((m, mi) => {
            const isNewGroup = mi===0 || FACT_METRICS[mi-1].group!==m.group;
            return (
              <div key={m.key}>
                {isNewGroup && (
                  <div style={{ display:'flex', height:20 }}>
                    <div style={{ width:LABEL_W, minWidth:LABEL_W, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12 }}>
                      <span style={{ fontSize:9, fontWeight:700, color:'rgba(200,215,235,0.3)', textTransform:'uppercase', letterSpacing:'0.8px' }}>{m.group}</span>
                    </div>
                    {allCols.map((_,ci)=><div key={ci} style={{ width:_.type==='total'?TOTAL_W:COL_W, minWidth:_.type==='total'?TOTAL_W:COL_W, flexShrink:0, background:'rgba(255,255,255,0.01)' }}/>)}
                  </div>
                )}
                <div style={{ display:'flex', height:ROW_H, borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
                  <div style={{ width:LABEL_W, minWidth:LABEL_W, flexShrink:0, height:ROW_H, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.15)', display:'flex', alignItems:'center', paddingLeft:12, fontSize:11, color:'rgba(200,215,235,0.8)' }}>{m.label}</div>
                  {allCols.map((col,ci) => {
                    const isT = col.type==='total';
                    const isFact = !isT && !!dayMap[col.date];
                    const isToday = !isT && col.date===today;
                    const isCur = col.week.from<=today && col.week.to>=today;
                    let val = null;
                    if (isT) {
                      val = m.sum
                        ? sumW(col.week.days, forecastMap, m.fn)
                        : avgW(col.week.days, forecastMap, m.fn);
                    } else {
                      val = m.fn(forecastMap[col.date]||{});
                    }
                    const empty = val==null;
                    const isForecastCell = !isT && !isFact;
                    return <div key={ci} style={{ width:isT?TOTAL_W:COL_W, minWidth:isT?TOTAL_W:COL_W, flexShrink:0, height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', background:isT?'rgba(99,102,241,0.1)':isToday?'rgba(251,191,36,0.06)':isCur?'rgba(99,102,241,0.04)':'transparent', borderRight:isT?'2px solid rgba(255,255,255,0.1)':'1px solid rgba(255,255,255,0.03)', fontSize:10, color:empty?'rgba(200,215,235,0.18)':isT?'#a5b4fc':isToday?'#fbbf24':isForecastCell?'rgba(200,215,235,0.4)':'rgba(200,215,235,0.85)', fontWeight:isT||isToday?600:400, fontStyle:isForecastCell?'italic':'normal', boxSizing:'border-box' }}>
                      {empty ? '—' : m.fmt(val)}
                    </div>;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ─── Главный компонент ───────────────────────────────────────────────────────
export default function SeasonStats({ strategyId, nmId, seasonStart, seasonDays, profitRK, profitNoRK, buyoutAvg, price, drr }) {
  const [data, setData]       = useState(null);
  const buyoutHistory = data?.buyoutHistory || [];
  const weekSnapshots = data?.weekSnapshots || [];
  const [loading, setLoading] = useState(false);
  const [open1, setOpen1]     = useState(true);
  const [open2, setOpen2]     = useState(false);
  const [open3, setOpen3]     = useState(false);
  const [open4, setOpen4]     = useState(false);

  useEffect(()=>{
    if (!strategyId||!nmId||!seasonStart||!seasonDays) return;
    setLoading(true);
    api.get(`/strategies/${strategyId}/season-stats?nmId=${nmId}`)
      .then(r=>setData(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, [strategyId, nmId, seasonStart, seasonDays]);

  if (!nmId) return null;

  const today = new Date().toISOString().split('T')[0];
  const weeks = seasonStart&&seasonDays ? getWeeks(seasonStart, seasonDays) : [];
  const dayMap = {};
  if (data?.days) data.days.forEach(d=>{ dayMap[d.date]=d; });
  const conv = data?.conv||{};

  const Block = ({title, color, open, setOpen, children}) => (
    <div style={{ marginTop:12, background:'#0a0f1a', border:'1px solid rgba(255,255,255,0.1)', borderRadius:12, overflow:'hidden' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', cursor:'pointer', borderBottom: open?'1px solid rgba(255,255,255,0.08)':'none' }} onClick={()=>setOpen(s=>!s)}>
        <span style={{ fontSize:13, fontWeight:700, color:color||'#e2e8f0' }}>{title}</span>
        <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)' }}>{open?'▼':'▶'}</span>
      </div>
      {open && children}
    </div>
  );

  return (
    <div style={{ marginTop:20 }}>
      <div style={{ fontSize:14, fontWeight:700, color:'rgba(200,215,235,0.8)', marginBottom:8 }}>
        Сезонная аналитика · {loading&&<span style={{fontSize:11,color:'rgba(200,215,235,0.4)'}}>загрузка...</span>}
      </div>

      <Block title="Блок 1 — Факт по неделям (все метрики)" color="#e2e8f0" open={open1} setOpen={setOpen1}>
        <HTable weeks={weeks} dayMap={dayMap} metrics={FACT_METRICS} today={today} profitRK={profitRK} profitNoRK={profitNoRK} buyoutAvg={buyoutAvg} price={price} drr={drr} buyoutHistory={buyoutHistory} weekSnapshots={weekSnapshots}/>
      </Block>

      <Block title="Блок 2 — Реклама отдельно" color="#f59e0b" open={open2} setOpen={setOpen2}>
        <HTable weeks={weeks} dayMap={dayMap} metrics={ADV_METRICS} today={today} profitRK={profitRK}/>
      </Block>

      <Block title="Блок 3 — Корректировка прогноза" color="#a855f7" open={open3} setOpen={setOpen3}>
        <ForecastEdit conv={conv} weeks={weeks} today={today} profitRK={profitRK} profitNoRK={profitNoRK}/>
      </Block>

      <Block title="Блок 4 — Авто-прогноз из факта" color="#10b981" open={open4} setOpen={setOpen4}>
        <AutoForecast weeks={weeks} dayMap={dayMap} today={today} profitRK={profitRK} profitNoRK={profitNoRK} conv={conv}/>
      </Block>
    </div>
  );
}
